// extracted by mini-css-extract-plugin
module.exports = {"snackbarContainer":"snack-bar-provider_snackbarContainer__FEyoB"};